var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconS2IGetStarted = function SvgIconS2IGetStarted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_s2i_get_started_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.918 13.248a1.274 1.274 0 0 1-1.245-1.545L9.4 8.33 7.082 5.772a1.27 1.27 0 0 1-.16-1.494 1.269 1.269 0 0 1 1.374-.606l3.374.728 2.557-2.319a1.27 1.27 0 0 1 1.494-.159c.481.278.724.83.606 1.373L15.6 6.67l2.318 2.558a1.27 1.27 0 0 1 .16 1.492 1.27 1.27 0 0 1-1.373.608l-3.374-.73-2.559 2.32a1.27 1.27 0 0 1-.854.331Zm.974-4.716-.605 2.8 2.122-1.924c.303-.274.72-.387 1.122-.301l2.802.605-1.924-2.122a1.275 1.275 0 0 1-.3-1.126l.604-2.798L12.59 5.59a1.277 1.277 0 0 1-1.126.3l-2.798-.604 1.924 2.122c.275.304.388.724.3 1.124ZM3.346 18.252a.751.751 0 0 1-.734-.908l.307-1.418-.975-1.074a.75.75 0 0 1 .714-1.238l1.418.307 1.074-.974a.75.75 0 0 1 1.237.714l-.306 1.417.975 1.075a.75.75 0 0 1-.714 1.237l-1.418-.307-1.074.975a.752.752 0 0 1-.504.194Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_s2i_get_started_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
};
export default SvgIconS2IGetStarted;